import React from "react";
import { SpeakerHigh, Pause, Play, CircleNotch } from "@phosphor-icons/react";
import { useTTS } from "../lib/useTTS";
import { buildReadingText } from "../lib/readingText";

export default function ListenButton({ item, isPrema = false, phaseLabel = "" }) {
  const { status, toggle } = useTTS();

  const onClick = () => {
    const text = buildReadingText(item, { isPrema, phaseLabel });
    toggle(text);
  };

  const isLoading = status === "loading";
  const isPlaying = status === "playing";

  let label = "Écouter la fiche";
  if (isLoading) label = "Préparation de la voix…";
  else if (isPlaying) label = "Mettre en pause";
  else if (status === "paused") label = "Reprendre l'écoute";
  else if (status === "error") label = "Réessayer l'écoute";

  return (
    <button
      data-testid="listen-btn"
      onClick={onClick}
      disabled={isLoading}
      className="inline-flex items-center gap-2.5 rounded-full bg-[#9CAEA9] px-5 py-3 text-[14px] font-bold text-white shadow-sm transition-colors hover:bg-[#88A096] disabled:opacity-80"
    >
      {isLoading ? (
        <CircleNotch size={20} weight="bold" className="animate-spin" />
      ) : isPlaying ? (
        <Pause size={20} weight="fill" />
      ) : status === "paused" ? (
        <Play size={20} weight="fill" />
      ) : (
        <SpeakerHigh size={20} weight="fill" />
      )}
      {label}
    </button>
  );
}
